module.exports = __webpack_public_path__ + "assets/img/ncoin-gray.958201df.svg";